import React from 'react'
import { Col, Divider, Row } from 'antd'
import { numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { QuotationData } from 'Store/quotation/types'
import { DiscountType, VAT_TYPE, VAT_TYPE_TEXT } from 'helpers/constanst'
import { SupplierOrderData } from 'Store/supplier-order/types'

type Props = {
  detail?: QuotationData | SupplierOrderData
  vat?: number
  refundAmount?: number
}

const QuotationSummay: React.FunctionComponent<Props> = props => {
  const { detail, vat = 0, refundAmount = 0 } = props
  let percentVat = 0
  if (vat === 7) {
    percentVat = vat
  }

  const countTotal = () => {
    let amount = 0
    let price = 0
    detail &&
      detail.products &&
      detail.products.forEach(item => {
        const totalPrice = (item.quantity || 0) * (item.price || 0)
        amount += item.price
        price += totalPrice
      })
    return { amount, price }
  }

  const getDiscount = () => {
    const totalPrice = countTotal().price
    let discount: number = detail?.discount || 0
    if (detail?.discount_type === 'percent') {
      discount = (totalPrice * discount) / 100
    }
    return discount
  }

  const productPriceAfterProductDiscount =
    (detail?.total_product_price_before_discount || 0) - (detail?.total_product_discount || 0)
  const hasProductDiscount = (detail?.total_product_discount || 0) > 0
  const isExcludeVat = detail?.vat_type === VAT_TYPE.EX
  const discountThb = getDiscount()
  const tailDiscount = discountThb > 0
  const priceBeforeVat = productPriceAfterProductDiscount - discountThb - refundAmount

  const calculateVat = () => {
    if (isExcludeVat) {
      const vat = (percentVat * priceBeforeVat) / 100
      const total_amount = priceBeforeVat + vat
      return { vat, total_amount }
    } else {
      const priceExcludeVat = (priceBeforeVat * 100) / (100 + percentVat)
      const vat = priceExcludeVat * (percentVat / 100)
      return { vat, total_amount: priceBeforeVat }
    }
  }

  const netPrice = calculateVat().total_amount

  return (
    <>
      {hasProductDiscount && (
        <Row justify="space-between">
          <Col>
            <InfoTitle>รวมราคาสินค้าก่อนหักส่วนลด</InfoTitle>
          </Col>
          <Col>
            <InfoTitle>
              {numberWithComma(detail?.total_product_price_before_discount || 0, true)} บาท
            </InfoTitle>
          </Col>
        </Row>
      )}
      {hasProductDiscount && (
        <Row justify="space-between">
          <Col>
            <InfoTitle>หัก ส่วนลดสินค้า</InfoTitle>
          </Col>
          <Col>
            <InfoTitle>{numberWithComma(detail?.total_product_discount || 0, true)} บาท</InfoTitle>
          </Col>
        </Row>
      )}
      {/* <Divider style={{ margin: '10px 0' }} /> */}
      <Row justify="space-between">
        <Col>
          <InfoTitle>รวมราคาสินค้า</InfoTitle>
        </Col>
        <Col>
          <InfoTitle>{numberWithComma(productPriceAfterProductDiscount || 0, true)} บาท</InfoTitle>
        </Col>
      </Row>
      {tailDiscount && (
        <Row justify="space-between">
          <Col>
            <InfoTitle>
              หัก ส่วนลดท้ายบิล
              {detail?.discount_type === DiscountType.PERCENT ? `(${detail?.discount || 0}%)` : ''}
            </InfoTitle>
          </Col>
          <Col>
            <InfoTitle>{numberWithComma(discountThb, true)} บาท</InfoTitle>
          </Col>
        </Row>
      )}
      {refundAmount > 0 && (
        <Row justify="space-between">
          <Col>
            <InfoTitle>หัก คืนเงิน/คืนสินค้า</InfoTitle>
          </Col>
          <Col>
            <InfoTitle> {numberWithComma(refundAmount, true)} บาท </InfoTitle>
          </Col>
        </Row>
      )}
      <Row justify="space-between">
        <Col>
          <InfoTitle>ราคารวมทั้งสิ้น</InfoTitle>
        </Col>
        <Col>
          <InfoTitle>
            {numberWithComma(priceBeforeVat, true)}
            บาท
          </InfoTitle>
        </Col>
      </Row>
      <Row justify="space-between">
        <Col>
          <InfoTitle>
            ภาษีมูลค่าเพิ่ม {percentVat}% (
            {detail?.vat_type === VAT_TYPE.EX ? VAT_TYPE_TEXT.EX : VAT_TYPE_TEXT.IN})
          </InfoTitle>
        </Col>
        <Col>
          <InfoTitle>{numberWithComma(calculateVat().vat, true)} บาท</InfoTitle>
        </Col>
      </Row>
      <Divider style={{ margin: '10px 0' }} />
      <Row justify="space-between">
        <Col>
          <InfoTitle>จำนวนเงินรวมทั้งสิ้น</InfoTitle>
        </Col>
        <Col>
          <InfoTitle>{numberWithComma(netPrice, true)} บาท</InfoTitle>
        </Col>
      </Row>
    </>
  )
}

const InfoTitle = styled.span`
  // font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

export default QuotationSummay
